// Velo API Reference: https://www.wix.com/velo/reference/api-overview/introduction

$w.onReady(function () {

	// Write your Javascript code here using the Velo framework API

	// Print hello world:
	// console.log("Hello world!");

	// Call functions on page elements, e.g.:
	// $w("#button1").label = "Click me!";

	// Click "Run", or Preview your site, to execute your code

	$w.onReady(function () {
    const currentYear = new Date().getFullYear();
    const startYear = 2015; // Replace with the starting year of your site
    const copyrightText = `© Copyright ${startYear}-${currentYear} Loop, all rights reserved.`;
    $w('#copyrightText').text = copyrightText;
});


});